const PERCENTAGE_SYMBOL = '%';

const formatToPercentage = (value: number, decimals = 2): string => {
  return `${Number(value).toFixed(decimals)}${PERCENTAGE_SYMBOL}`;
};

export { formatToPercentage };
